<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="收发存"
      :page="page"
      :show-query="true"
      v-if="trendShow"
      :query-before="queryBefore"
      :queryParamsAppend="params"
      :resetDataFunc="resetDataFunc"
      urlHash="business/stock/transceiverstorage"
      :get-data-func="getDataFunc"
      :show-summary="summaryShow"
      :summary-method="summaryFunc"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="primary" @click="onExport">导出</el-button>
      </template>
      <template slot="query">
        <el-form-item label="存货">
          <select-input
            placeholder="存货"
            :label="ProductName"
            v-model="params.ProductId"
            @click="openProduct"
            style="width: 180px"
          />
        </el-form-item>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <list-dialog ref="listDialog" in-dialog selectable @select="setProduct" />
  </div>
</template>
<script>
import listDialog from "@/components/basedata/inventory/archives/listDialog";

import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list, listDialog },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  data() {
    return {
      api: require("@/api/stock/stReport").default,
      trendShow: true,
      tableData: [],
      ProductName: "",
      params: {
        StartTime: "",
        EndTime: "",
        ProductId: null,
        SubUnitType: null,
      },
      summaryShow: false,
      total: null,
    };
  },
  created() {
    // let {start, end} = this.cycleChange('本月');
    // this.params.StartTime = start;
    // this.params.EndTime = end;
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.stSummaryRpt(params).then((res) => {
          let times = Math.ceil(res.Count / params.pageSize);
          //判断是否最后一页
          if (times == params.pageIndex) {
            this.api.stSummaryRptTotal(params).then((res) => {
              if (res.Code == 0 && res.Data) {
                this.total = res.Data[0];
                this.summaryShow = true;
              } else {
                this.summaryShow = false;
              }
            });
          } else {
            this.summaryShow = false;
          }
          resolve(res);
        });
      });
    },
    /** 千位符加两位小数 */
    summaryFunc(param) {
      const { columns, data } = param;
      var fields = [
        "BeginBaseQuantity",
        "BeginAmount",
        "InBaseQuantity",
        "InAmount",
        "OutBaseQuantity",
        "OutAmount",
        "FinalBaseQuantity",
        "FinalAmount",
      ]; //需要合计的字段
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        var field = fields.find((x) => x == column.property);
        if (field) {
          console.log(field, index);
          sums[index] = "";
          if (this.total) {
            sums[index] = this.total[field].toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = list.tableList.map((x) => x.tableName);
          var params = { ...listParams, Fields: fields.join(",") };
          // console.log('onExport', params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.stSummaryRptExport(params).then((res) => {
            loading.close();
          });
        })
        .catch(() => {});
    },
    queryBefore() {
      let item = this.$refs.list.paramsData.filter((item) => {
        return item.field === "StartTime";
      })[0];
      if (!item.value || !item.value[0] || !item.value[1]) {
        this.$message({
          type: "warning",
          message: "温馨提示，选择单据日期后才能查询",
        });
        return false;
      } else {
        return true;
      }
    },
    setProduct(data) {
      this.ProductName = data.ProductName;
      this.params.ProductId = data.ProductId;
    },
    openProduct() {
      this.$refs.listDialog.open();
    },
    resetDataFunc(data) {
      //FirstAvgQuantityPrice
      // data.forEach(item=>{
      // item.FirstAvgQuantityPrice=item.FirstAvgQuantityPrice.toFixed(2)
      // item.LastAvgQuantityPrice=item.LastAvgQuantityPrice.toFixed(2)
      // })
      return data;
      // console.log(data,'data==========')
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs().subtract(2, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs().subtract(6, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs().subtract(13, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs().startOf("week").format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs().startOf("month").format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs().startOf("quarter").format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs().startOf("year").format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }

      return {
        start,
        end,
      };
    },
  },
};
</script>
